{
  "name": "kaplay",
  "description": "KAPLAY is a JavaScript & TypeScript game library that helps you make games fast and fun! (formerly known as Kaboom.js)",
  "version": "3001.0.18",
  "license": "MIT",
  "homepage": "https://kaplayjs.com/",
  "bugs": {
    "url": "https://github.com/kaplayjs/kaplay/issues"
  },
  "funding": {
    "type": "opencollective",
    "url": "https://opencollective.com/kaplay"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/kaplayjs/kaplay.git"
  },
  "type": "module",
  "main": "./dist/kaplay.cjs",
  "module": "./dist/kaplay.mjs",
  "types": "./dist/doc.d.ts",
  "readme": "./README.md",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/doc.d.ts",
        "default": "./dist/kaplay.mjs"
      },
      "require": {
        "types": "./dist/doc.d.ts",
        "default": "./dist/kaplay.cjs"
      }
    },
    "./global": "./dist/declaration/global.js"
  },
  "typesVersions": {
    "*": {
      "global": [
        "./dist/declaration/global.d.ts"
      ]
    }
  },
  "keywords": [
    "game development",
    "javascript",
    "typescript",
    "game engine",
    "2d games",
    "physics engine",
    "webgl",
    "canvas",
    "game library",
    "kaplay",
    "kaboom",
    "kaboomjs",
    "kaboom.js"
  ],
  "files": [
    "dist/",
    "kaplay.webp",
    "CHANGELOG.md"
  ],
  "scripts": {
    "dev": "NODE_ENV=development node scripts/dev.js",
    "win:dev": "set NODE_ENV=development && node scripts/dev.js",
    "build": "node scripts/generateIndex.js && npm run doc-dts && node scripts/build.js",
    "build:fast": "node scripts/buildFast.js",
    "check": "tsc",
    "fmt": "dprint fmt",
    "test": "node scripts/test.js",
    "doc-dts": "dts-bundle-generator -o dist/doc.d.ts src/index.ts",
    "test:vite": "vitest --typecheck",
    "desktop": "tauri dev",
    "prepare": "npm run build",
    "publish:next": "npm publish --tag next"
  },
  "devDependencies": {
    "@kaplayjs/dprint-config": "^1.2.0",
    "@types/jest": "^29.5.14",
    "dprint": "^0.49.1",
    "dts-bundle-generator": "^9.5.1",
    "ejs": "^3.1.10",
    "esbuild": "^0.25.2",
    "express": "^5.1.0",
    "puppeteer": "^22.15.0",
    "tar-fs": "3.0.8",
    "typescript": "5.6.3",
    "vite": "5.4.16",
    "vitest": "^3.1.1",
    "vitest-environment-puppeteer": "^11.0.3",
    "vitest-puppeteer": "^11.0.3"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "packageManager": "pnpm@9.9.0+sha512.60c18acd138bff695d339be6ad13f7e936eea6745660d4cc4a776d5247c540d0edee1a563695c183a66eb917ef88f2b4feb1fc25f32a7adcadc7aaf3438e99c1"
}
